import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './boxRounded.module.scss'

const BoxRounded = ({
  active,
  width,
  height,
  padding,
  margin,
  darkGradient,
  children,
  className
}) => {
  const boxRoundedClasses = classNames(styles.container, className, {
    [styles.primaryLigth]: active,
    [styles.darkGradient]: darkGradient
  })

  const boxRoundedStyles = {}
  if (width) boxRoundedStyles.width = width
  if (height) boxRoundedStyles.height = height
  if (padding) boxRoundedStyles.padding = padding
  if (margin) boxRoundedStyles.margin = margin

  return (
    <div className={boxRoundedClasses} style={boxRoundedStyles}>
      {children}
    </div>
  )
}

BoxRounded.defaultProps = {
  width: null,
  height: null,
  padding: null,
  active: false,
  margin: null,
  darkGradient: null,
  className: null
}

BoxRounded.propTypes = {
  active: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  padding: PropTypes.string,
  className: PropTypes.string,
  margin: PropTypes.string,
  darkGradient: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.element
  ]).isRequired
}

export default BoxRounded
